import _, {compact, includes, map} from "lodash/fp";
import {Tooltip} from "@material-ui/core";
import InfoIcon from "@mui/icons-material/Info";
import React from "react";
import {getJustTheDateInHk} from "./dateUtils";


const getHumanReadableReason = (conflictingJurisdiction, affiliatedSchool, notAccepted, participationIsOnlyWritten, noLongerAvailableToActAsAnArbitrator, overRoundCount, alreadyPaired, notAvailable, moreThanThreePairingsToday) => {

    let reason=[]
    if (conflictingJurisdiction) {
        reason.push('Conflicting Jurisdiction')
    }
    if (affiliatedSchool) {
        reason.push('Affiliated School')
    }
    if (notAccepted) {
        reason.push('Not accepted')
    }
    if (participationIsOnlyWritten) {
        reason.push('Only available for written')
    }
    if (noLongerAvailableToActAsAnArbitrator) {
        reason.push(`Switched participation to 'no longer available to act as an arbitrator'`)
    }
    if (overRoundCount) {
        reason.push('Over their selected round count')
    }
    if (alreadyPaired) {
        reason.push('Already Paired at this time')
    }
    if (notAvailable) {
        reason.push('Unavailable at this time')
    }
    if(moreThanThreePairingsToday){
        reason.push('Paired more than 3 times today')
    }

    return _.join(', ',reason)

}
export const hasConflict = (claimant,respondent,arbitrator) => {

    if (!arbitrator) return false

    const conflictingJurisdictionNames = map(j => j.name ,arbitrator?.conflictingJurisdictions)
    const affiliatedSchoolNames = map(j => j.name ,arbitrator?.affiliatedSchools)

    const conflictingJurisdiction =includes(claimant?.jurisdiction,conflictingJurisdictionNames) || includes(respondent?.jurisdiction,conflictingJurisdictionNames)
    const affiliatedSchool =includes(claimant?.school,affiliatedSchoolNames) ||
        includes(respondent?.school,affiliatedSchoolNames)

    const notAccepted = arbitrator?.status !== 'accepted'
    const participationIsOnlyWritten =  arbitrator?.participation === 'I am available ONLY to rank written memoranda'
    const noLongerAvailableToActAsAnArbitrator = arbitrator?.participation === 'I am no longer able to act as an arbitrator'
    const overRoundCount = arbitrator?.isOverRoundCount === true
    const alreadyPaired = arbitrator.isAlreadyPaired === true
    const notAvailable =    arbitrator.isAvailable === false
    const moreThanThreePairingsToday = arbitrator.isPairedMoreThanThreeTimesToday === true

    const isConflicted = conflictingJurisdiction
        || affiliatedSchool
        || notAccepted
        || participationIsOnlyWritten
        || noLongerAvailableToActAsAnArbitrator
        || overRoundCount
        || alreadyPaired
        || notAvailable
        ||moreThanThreePairingsToday

    const reason = getHumanReadableReason(conflictingJurisdiction, affiliatedSchool, notAccepted, participationIsOnlyWritten, noLongerAvailableToActAsAnArbitrator, overRoundCount, alreadyPaired, notAvailable,moreThanThreePairingsToday)
    return {isConflicted, reason }
}

export const buildArbitratorOptionList = (claimant,respondent,allArbitrators, pairingTime,schedule,pairingId) => {
    const arbs = compact(map(a=> {
        if (a?.status === 'accepted') {
            const { isConflicted, reason} = hasConflict(claimant,respondent,augmentArbitrator(a,pairingTime,schedule,pairingId))
            return {id: a.id, name: `${a.firstName} ${a.lastName}`, isConflicted, reason }
        }
        return null
    },allArbitrators))

    return [{id: -1, name: "--Select Arbitrator--"},...arbs]
}

export const getArbitratorConflictGridCell = (claimant,respondent,arbitrator,pairingTime,schedule,pairingId) => {
    const {isConflicted,reason} = hasConflict(claimant, respondent,augmentArbitrator(arbitrator,pairingTime,schedule,pairingId))
    const arbitratorName = `${arbitrator?.firstName ?? ''} ${arbitrator?.lastName ?? ''}`.trim()
    return arbitrator?.id && (
            <span className={isConflicted ? 'arbitrator-conflict' : ''}>
                {isConflicted ? (
                    <Tooltip title={reason}>
                        <span style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                            {arbitratorName}
                            <InfoIcon sx={{fontSize: 14, marginLeft: '2px'}}/>
                        </span>
                    </Tooltip>
                ) : (
                    arbitratorName
                )}                
            </span>
        )

}


// This is duplicated (mostly) from the API side, it don't love that but I think it has o exist
// here as well to be able to determine the conflicts dynamically based on each individual pairing
// We know the arbitrators conflicts relative to the pairing IF they are the selected arbitrator
// that is why the grid works, but in the drop down we have to calculate these conflicts for every
// arbitrator in the drop down for every pairing. We would be returning
const isArbitratorOverRoundCount = (arbitrator,schedule) => {
    if (!arbitrator) return false
    const id = arbitrator.id
    const arbitratorActualRoundCount = _.sumBy(s => s.chairArbitratorId === id || s.secondArbitratorId === id || s.thirdArbitratorId === id ? 1 : 0,schedule)
    return arbitrator.roundsYouCanArbitrate < arbitratorActualRoundCount
}
const isArbitratorAvailable = (arbitrator,pairingTime) => {
    if (!arbitrator) return false
    const availableTimes = _.map(s => s?.available,arbitrator.schedule)
    return availableTimes.includes(pairingTime) //?
}
const isAlreadyPairedForThisTimeSlot = (arbitrator,pairingTime,pairingId,schedule) => {
    if (!arbitrator) return false
    const otherPairingsAtThisTime = _.filter(s => s.pairingTime === pairingTime && s.id !== parseInt(pairingId),schedule)

    const id = arbitrator.id
    const count = _.sumBy(s => s.chairArbitratorId === id || s.secondArbitratorId === id || s.thirdArbitratorId === id ? 1 : 0,otherPairingsAtThisTime)
    return count > 0
}

const isPairedMoreThanThreeTimesToday = (arbitrator,pairingTime,schedule) => {
    if (!arbitrator) return false
    const otherPairingsToday = _.filter(s => getJustTheDateInHk(s.pairingTime) === getJustTheDateInHk(pairingTime),schedule)
    const id = arbitrator.id
    const count = _.sumBy(s => s.chairArbitratorId === id || s.secondArbitratorId === id || s.thirdArbitratorId === id ? 1 : 0,otherPairingsToday)
    return count > 3
}

export const augmentArbitrator = (arbitrator,pairingTime,schedule,pairingId) => {
    console.log('augmenting')
    return {
        ...arbitrator,
        isOverRoundCount: isArbitratorOverRoundCount(arbitrator,schedule),
        isAvailable: isArbitratorAvailable(arbitrator, pairingTime),
        isAlreadyPaired: isAlreadyPairedForThisTimeSlot(arbitrator,pairingTime,pairingId,schedule),
        isPairedMoreThanThreeTimesToday: isPairedMoreThanThreeTimesToday(arbitrator,pairingTime,schedule),
    }
}